import { L2RButton, styledForMobile } from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 36
const MOBILE_BUTTON_SIZE = 44

export const IconButton = styledForMobile(L2RButton)(({ isMobile, theme }) => {
    const size = isMobile ? MOBILE_BUTTON_SIZE : BUTTON_SIZE

    return ({
        "&.MuiIconButton-root": {
            width: size,
            height: size,
            boxShadow: theme.customShadow("LCS/Shadow-simple"),
        },
    })
})